import { render, staticRenderFns } from "./AbsenceModal.vue?vue&type=template&id=1c9070e3"
import script from "./AbsenceModal.vue?vue&type=script&lang=ts"
export * from "./AbsenceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports